import BotAvatar from '../Components/UI/BotAvatar.jsx'
import CustomMessageBot from '../Components/UI/CustomMessageBot.jsx'
import SearchComponent from '../Containers/SearchComponent.jsx'
import BotStoryMessage from '../Containers/BotStoryMessage.jsx'
import { botNameApi } from '../Services/searchRequest.js'
import { createChatBotMessage } from '../Utils/messageUtils.js'
import StaticMessages from '../Components/UI/StaticMessages.jsx'

const requestBotNameApi = await botNameApi()
export const chatbotName = requestBotNameApi

const config = {
  initialMessages: [createChatBotMessage("Carregando a mensagem inicial...")],
  botName: chatbotName,
  customComponents: {
    botAvatar: (props) => <BotAvatar {...props} />,
  },
  customMessages: {
    SearchComponent: (props) => <SearchComponent {...props} />,
    CustomMessageBot: (props) => <CustomMessageBot {...props} />,
    BotStoryMessage: (props) => <BotStoryMessage {...props} />,
    StaticMessages: (props) => <StaticMessages {...props} />,
  },
}

export default config